export enum FILTER_BY {
	AllEvents = 'all',
	UpcomingEvents = 'upcoming',
	DateRange = 'date-range'
}
